export class MaritalStatus {
  public id?: string;
  public name: string;
}
